import { AxiosRequestConfig } from 'axios';

export class ResourceAlreadyExistError extends Error {
  message?: string;
  config?: AxiosRequestConfig;
  status: number | undefined;
  file: string | undefined;
  warnings: [] | undefined;
  errors?: unknown[];
  data: unknown;

  constructor(model: Partial<ResourceAlreadyExistError> = {}) {
    super();
    this.data = model.data;
    this.message = model.data?.message;
    this.status = model.status;
    this.config = model.config;
    this.file = model.file;
    this.warnings = model.warnings;
    this.errors = model.data?.errors;
  }
}
